import Button from 'components/button';
const ResponsibleInfoSection = ({ dataCreateMission, setPage }) => (
  <div className="mx-6 border-b border-gray-200 py-2">
    <div className="flex justify-between">
      <span className="ft-b text-gray-900 font-medium">
        Information responsable
      </span>
      <Button color="DEFAULT" size="SM" onClick={() => setPage(1)}>
        Modifier
      </Button>
    </div>
    <div className="flex flex-col gap-4">
      <div className="flex flex-col ft-sm">
        <span className="text-gray-900 font-medium">
          Nom complet du responsable :
        </span>{' '}
        {dataCreateMission.contact_name}
      </div>
      <div className="flex flex-col ft-sm">
        <span className="text-gray-900 font-medium">
          Poste du responsable :
        </span>{' '}
        {dataCreateMission.contact_poste}
      </div>
    </div>
  </div>
);

export default ResponsibleInfoSection;
